import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 2rem;
	overflow: auto;

	@media (max-width: 1000px) {
		margin-top: 1rem;
	}
`;
